import { Button, ButtonProps } from 'antd'
import styles from './VariantButton.module.scss'

interface IVariantButtonProps extends Omit<ButtonProps, 'type'> {
  text: string
  isActive?: boolean
  variant?: 'default' | 'outlined'
}

export const VariantButton: React.FC<IVariantButtonProps> = ({
  text,
  isActive = false,
  variant = 'outlined',
  className,
  ...props
}) => {
  return (
    <Button
      type='default'
      size='large'
      className={`${styles.button} ${isActive ? styles.active : ''} ${className || ''}`}
      {...props}
    >
      {text}
    </Button>
  )
} 